import {find} from 'lodash';

export const getTodaysSuperSale = (superSaleCards) => {
  const today = new Date();

  const todaysSuperSale = find(superSaleCards, (card) => {
    const cardDate = new Date(card.object ? card.object.display_date : card.display_date);
    return cardDate.getDate() === today.getDate() &&
    cardDate.getMonth() === today.getMonth() &&
    cardDate.getFullYear() === today.getFullYear();
  });

  if (todaysSuperSale) {
    return todaysSuperSale.object ? todaysSuperSale.object : todaysSuperSale;
  }

};
